import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavEditorActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.95002 17.7L23.34 4.31002C23.71 3.94002 23.92 3.44002 23.92 2.92002C23.92 2.40002 23.71 1.90002 23.34 1.52002L22.48 0.66002C21.71 -0.10998 20.46 -0.10998 19.69 0.66002L6.30002 14.05C6.16002 14.19 6.08002 14.38 6.08002 14.58V17.17C6.08002 17.58 6.42002 17.92 6.83002 17.92H9.42002C9.62002 17.92 9.81002 17.84 9.95002 17.7Z"
        fill={color}
      />
      <path
        d="M9.86999 20.7H8.85999C8.51757 20.7 8.23999 20.9776 8.23999 21.32V22.33C8.23999 22.6724 8.51757 22.95 8.85999 22.95H9.86999C10.2124 22.95 10.49 22.6724 10.49 22.33V21.32C10.49 20.9776 10.2124 20.7 9.86999 20.7Z"
        fill={color}
      />
      <path
        d="M19.7 18.07H18.69C18.3476 18.07 18.07 18.3476 18.07 18.69V19.7C18.07 20.0424 18.3476 20.32 18.69 20.32H19.7C20.0424 20.32 20.32 20.0424 20.32 19.7V18.69C20.32 18.3476 20.0424 18.07 19.7 18.07Z"
        fill={color}
      />
      <path
        d="M15.32 21.44H14.31C13.9676 21.44 13.69 21.7176 13.69 22.06V23.07C13.69 23.4124 13.9676 23.69 14.31 23.69H15.32C15.6624 23.69 15.94 23.4124 15.94 23.07V22.06C15.94 21.7176 15.6624 21.44 15.32 21.44Z"
        fill={color}
      />
      <path
        d="M23.07 13.69H22.06C21.7176 13.69 21.44 13.9676 21.44 14.31V15.32C21.44 15.6624 21.7176 15.94 22.06 15.94H23.07C23.4124 15.94 23.69 15.6624 23.69 15.32V14.31C23.69 13.9676 23.4124 13.69 23.07 13.69Z"
        fill={color}
      />
      <path
        d="M22.47 8.73999H21.46C21.1176 8.73999 20.84 9.01757 20.84 9.35999V10.37C20.84 10.7124 21.1176 10.99 21.46 10.99H22.47C22.8124 10.99 23.09 10.7124 23.09 10.37V9.35999C23.09 9.01757 22.8124 8.73999 22.47 8.73999Z"
        fill={color}
      />
      <path
        d="M3.97003 18.44L1.83003 10.44C1.62003 9.66003 1.85003 8.83003 2.41003 8.27003L8.27003 2.41003C8.83003 1.85003 9.66003 1.62003 10.44 1.83003L14.81 3.00003C15.22 3.11003 15.62 2.87003 15.73 2.47003C15.84 2.07003 15.6 1.66003 15.2 1.55003L10.83 0.380026C9.54003 0.0400263 8.15003 0.410026 7.21003 1.35003L1.35003 7.20003C0.410026 8.14003 0.0400263 9.53003 0.380026 10.82L2.53003 18.82C2.70003 19.45 3.03003 20.03 3.50003 20.5C3.79003 20.79 4.27003 20.79 4.56003 20.5C4.85003 20.21 4.85003 19.73 4.56003 19.44C4.28003 19.16 4.08003 18.81 3.98003 18.43L3.97003 18.44Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavEditorActiveIcon.displayName = 'NavEditorActiveIcon';
